import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "AIChatThread",
})
export default class AIChatThread extends Vue {
  @Prop({ default: [] }) messages;
  @Prop({ default: false }) loading;
  showScrollDownButton = false;

  onScroll(event) {
    const chatThread = event.target;
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop === 0) {
      this.$emit("scrollToTop");
    }
    if (scrollTop + clientHeight === scrollHeight) {
      this.$emit("scrollToBottom");
    }
    if (chatThread.scrollTop < chatThread.scrollHeight - chatThread.clientHeight - 250) {
      this.showScrollDownButton = true;
    } else {
      this.showScrollDownButton = false;
    }
  }

  render() {
    return (
      <div class="ai-chat-thread" onScroll={this.onScroll} >
        {this.messages.map((message, index) => (
          <div
            class={[
              "ai-message",
              message.type === "user" ? "ai-user-message" : "ai-chatbot-message",
            ]}
            key={message.id}
            id={`ai-message-${message.id}`}
          >
            {message.type === "user" ? (
              <div>{message.text}</div>
            ) : (
              <div class="ai-chatbot-message-card">
                <img
                  src="static/icons/chatbot.svg"
                  alt="Chatbot icon"
                  class="ai-message-icon"
                  style={`
                  box-shadow: 0px 2px 6px #00000029;
                  width: 40px;
                  height: 40px;
                  padding: 6px;
                  border-radius: 45px;
                  `}
                />
                {message.loading ?
                  <div class={`ut-colcen`} style={{ height: `56px` }}>
                    <svg width="30" height="10" viewBox="0 0 30 10" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="5" cy="5" r="3" fill="#000">
                        <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0s" repeatCount="indefinite" />
                      </circle>
                      <circle cx="15" cy="5" r="3" fill="#000">
                        <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.1s" repeatCount="indefinite" />
                      </circle>
                      <circle cx="25" cy="5" r="3" fill="#000">
                        <animate attributeName="opacity" from="1" to="0" dur="1s" begin="0.2s" repeatCount="indefinite" />
                      </circle>
                    </svg>
                  </div>
                  : <TypeWritingP class={
                    `${message.cancelled ? 'cancelled' : ''}`
                  } text={message.text} animate={message?.newResponse}
                    onAnimationDone={() => {
                      this.$emit('animationDone', message.id);
                      console.log({ 'ai-chat-thread.js:74 animationDone': message.id });
                    }}
                  />
                }
              </div>
            )}
          </div>
        ))}
        <img src="static/icons/arrows/arrow-down-blue.svg" alt="Scroll down"
          class="scroll-down-button"
          style={{
            opacity: this.showScrollDownButton ? '1' : '0',
            transition: `opacity 200ms ease-out`,
            // bottom: 98px;
            // right: 20px;
            // border-radius: 30px;
            // background-color: white;
            // box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 6px;
            // bottom: `98px`,
            // right: `20px`,
            // borderRadius: `30px`,
            // backgroundColor: `white`,
            // boxShadow: `rgba(0, 0, 0, 0.16) 0px 2px 6px`,
            // zIndex: 91,
            // cursor: `pointer`,
          }}
          onClick={() => {
            const aiChatThread = document.querySelector(`.ai-chat-thread`);
            aiChatThread.scrollTo({
              top: aiChatThread.scrollHeight,
              behavior: 'smooth',
            });
          }} />
        {(!this.loading && this.messages.length === 0) && <div class="ut-colcen" style={{ height: `100%` }}>
          <div class={`ut-text-secondary ut-rowcen`}>
            No Chat History
          </div>
        </div>}
      </div>
    );
  }
}


@Component({
  name: 'TypeWritingP'
})
export class TypeWritingP extends Vue {
  @Prop({ default: '' }) text;
  @Prop({ default: 1 }) minSpeed;
  @Prop({ default: 20 }) maxSpeed;
  @Prop({ default: false }) animate;
  animationDone = false;
  randomDelays = [];

  typedText = '';
  currentSpeed = this.maxSpeed || 20;

  typeChunks = [
    {
      text: 'Hello',
      typedText: '',
    },
    {
      br: true
    },
    {
      text: 'How are you?',
      typedText: '',
    }
  ];
  typedChunk = -1;

  typeWriter() {
    if (this.typedChunk < 0) {
      this.typeChunks = toTypeChunks(this.text);
      this.typedChunk = 0;
    }

    const currentChunk = this.typeChunks[this.typedChunk];
    // console.log({ 'ai-chat-thread.js:153 currentChunk': currentChunk });
    // console.log({ 'this': this, cs: this.currentSpeed, ms: this.maxSpeed });

    

    if (currentChunk.text && currentChunk.typedText.length < currentChunk.text.length && this.animate) {
      currentChunk.typedText += currentChunk.text.charAt(currentChunk.typedText.length);
      setTimeout(this.typeWriter, this.currentSpeed);
    } else if (!this.animate) {
      currentChunk.typedText = currentChunk.text;
      this.animationDone = true;
    } else if (this.typedChunk < this.typeChunks.length - 1) {
      this.typedChunk++;
      this.currentSpeed = this.getRandomSpeed();
      setTimeout(this.typeWriter, this.currentSpeed);
    } else {
      this.animationDone = true;
      this.$emit('animationDone');
    }

  }
  // typeWriter() {
  //   this.typeChunks = toTypeChunks(this.text);

  //   console.log({ 'ai-chat-thread.js:168 spans': spans });
  //   if (this.text && this.typedText.length < this.text.length && this.animate) {
  //     if (this.randomDelays.length > 0 && this.randomDelays[0] === this.typedText.length) {
  //       this.randomDelays.shift();
  //       setTimeout(this.typeWriter, 200);
  //     } else {
  //       this.typedText += this.text.charAt(this.typedText.length);
  //       this.currentSpeed = this.getRandomSpeed();
  //       setTimeout(this.typeWriter, this.currentSpeed);
  //     }
  //   } else if (!this.animate) {
  //     this.typedText = this.text;
  //     this.animationDone = true;
  //   } else {
  //     this.animationDone = true;
  //     // console.log({'ai-chat-thread.js:176 animationDone' : this.animationDone});
  //     this.$emit('animationDone');
  //   }
  // }

  getRandomSpeed() {
    const speedRange = this.maxSpeed - this.minSpeed;
    const randomSpeed = Math.random() * speedRange + this.minSpeed;
    return Math.floor(randomSpeed);
  }

  mounted() {
    const textLength = this.text.length;
    const delayPositions = [];
    for (let i = 0; i < 3; i++) {
      const position = Math.floor((i + 1) * textLength / 4);
      delayPositions.push(position);
    }
    this.randomDelays = delayPositions;
    this.typeWriter();
  }


  mounted() {
    this.typeWriter();
  }

  render() {
    return (
      <p class="typewritingp">
        {this.typeChunks.slice(0, this.typedChunk+1).map((chunk, index) => {
          if (chunk.br) {
            return <br />;
          } else if (chunk.text) {
            return <span>{chunk.typedText}</span>;
          } else {
            return null;
          }
        })}
        {!this.animationDone && <span class="typewriter-cursor">|</span>}
      </p>
    );
  }
}

const toTypeChunks = (text) => {
  const brSplit = text?.split('<br />');
  return brSplit?.map((chunk) => {
    return [
      {
        text: chunk,
        typedText: '',
      },
      {
        br: true
      }
    ]
  }).flat();
}
